import { useDarkMode } from "@/hooks/useDarkMode";
import { ToastContainer } from "react-toastify";

export function ThemedToastContainer() {
  const isDark = useDarkMode();
  return (
    <ToastContainer
      position="bottom-right"
      theme={isDark ? "dark" : "light"}
      toastClassName={(context) => {
        return " relative flex p-1 min-h-10 rounded-[10px] justify-between overflow-hidden cursor-pointer";
      }}
    />
  );
}
